import React from "react";
import QuantityPromoBadges from "./QuantityPromoBadges";
import "./ServiceNameWithPromos.css";
export default function ServiceNameWithPromos({ name, promos, className = "" }) {
  return <div className="service-name-with-promos">
    <span className={"service-name-with-promos__name " + className} title={name}>{name}</span>
    <QuantityPromoBadges promos={promos} />
  </div>;
}
